import * as React from 'react';
import { SelectArrayInput, SelectField, List, DateInput, TextInput, TextField, DateField, NumberField, Datagrid, NumberInput, SelectInput } from 'react-admin';
import { RaPagination } from '../../components/ra-list/RaList';
import ConditionalNumberField from './ConditionalNumberField';
import BulkUpdateStatusButton from './BulkUpdateStatusButton';
import dayjs from 'dayjs';

/** Generic `{ id, name }` choice used for the filter/status/type select inputs below. */
interface IChoice {
    id: string | number;
    name: string;
}

const DivvyCompanies: IChoice[] = [
    { id: 'Q29tcGFueTo2MDMwMQ==', name: 'Song Technologies LLC' },
    { id: 'Q29tcGFueTo2NjIyNQ==', name: 'Song Tech Prepay' },
];
const Status: IChoice[] = [
    { id: 0, name: 'Pending' },
    { id: 1, name: 'Completed' },
];
const TransactionType: IChoice[] = [
    { id: 0, name: 'Refund' },//amount <= 0
    { id: 1, name: 'Expense' },//amount > 0
];
const Type: IChoice[] = [
    { id: 'CLEAR', name: 'CLEAR' },//amount <= 0
    { id: 'AUTHORIZATION', name: 'AUTHORIZATION' },//amount > 0
];

const postFilters = [
    <SelectInput label="TransactionType" source="transactionType" choices={TransactionType} emptyText="ANY" alwaysOn />,
    <SelectInput label="Status" source="status" choices={Status} emptyText="ANY" alwaysOn />,
    <SelectArrayInput label="Company" source="companyId_in" choices={DivvyCompanies} emptyText="ANY" alwaysOn />,
    <SelectInput label="Type" source="type" choices={Type} emptyText="ANY" alwaysOn />,
    //<SelectArrayInput label="Exclude Company" source="companyId_nin" choices={DivvyCompanies} alwaysOn />, // demo 'not in'
    <DateInput label="Cleared At After" source="clearedAt_ge" alwaysOn parse={(date) => (date ? new Date(date + 'T00:00:00Z') : null)}/>,
    <DateInput label="Cleared At Before" source="clearedAt_le" alwaysOn parse={(date) => (date ? new Date(date + 'T23:59:59Z') : null)} />,
    <NumberInput label="Amount from" source="amount_ge" sx={{ width: 130 }} alwaysOn />,
    <NumberInput label="Amount to" source="amount_le" sx={{ width: 130 }} alwaysOn />,
    <NumberInput label="LocalAmount from" source="localAmount_ge" sx={{ width: 160 }} alwaysOn />,
    <NumberInput label="LocalAmount to" source="localAmount_le" sx={{ width: 160 }} alwaysOn />,
    <TextInput source="lastFour" alwaysOn />,
    <TextInput source="cardName" alwaysOn />,
    <TextInput source="cleanedMerchantName" alwaysOn />,
];

const DivvytransactionList = () => (
    <List
        storeKey={false}
        disableSyncWithLocation
        exporter={false}
        pagination={<RaPagination />}
        perPage={25}
        sort={{ field: 'clearedAt', order: 'DESC' }}
        filters={postFilters}
        filterDefaultValues={{
            // 'clearedAt_ge': new Date((new Date().setHours(0,0,0) - 15 * 24 * 60 * 60 * 1000)),
            'clearedAt_ge': dayjs().utc().startOf('day').subtract(15, 'day').toISOString(),
            'status': 0,
            'type': 'CLEAR',
            'transactionType': 0
        }}>

        <Datagrid bulkActionButtons={<BulkUpdateStatusButton />}>
            <SelectField source="companyId" choices={DivvyCompanies} translateChoice={false} />
            {/* <TextField source="budget" /> */}
            <TextField source="lastFour" />
            <TextField source="cardName" />
            <NumberField source="amount" options={{ style: 'currency', currency: 'USD' }} />
            <ConditionalNumberField source="localAmount" options={{ style: 'currency', currency: 'CAD' }} />
            <TextField source="cleanedMerchantName" />
            <TextField source="merchantName" />
            <DateField source="clearedAt" options={{ year: 'numeric', month: 'short', day: 'numeric' }} />
            <TextField source="type" />
            <SelectField source="status" choices={Status} translateChoice={false} />
            {/* <TextField source="subtype" /> */}
            {/* <TextField source="userName" /> */}
        </Datagrid>
    </List>
);
const DivvyPage = {
    name: 'DivvyTransaction',
    list: DivvytransactionList
};
export default DivvyPage;
